import { Navbar } from "../../components/navbar"
import { homeWorkData } from "../../json/HomeWorkData"
import { Footer } from "../../components/footer";
import { Collab } from "../../components/collab";
import { ProjectHeader } from "../../components/ProjectHeader";
import { ProjectDescription } from "../../components/ProjectDescription";

export const VirusScope = () => {
    const findProjectByTitle = (title) => (
        homeWorkData.find(project => project.title === title)
    )

    const project = findProjectByTitle("Virus Scope")
    // console.log(project);

    return (
        <>
            <Navbar />
            <ProjectHeader props={project} imgNumber={0} />
            {/* Desc */}
            <ProjectDescription props={project}/>
            {/* Images */}
            <section className="px-[16px] md:px-[32px] lg:px-[192px] bg-gradient-to-b from-[#FCFCFC] to-[#ebf3f3] pt-[1.5rem] pb-[8rem] md:pb-[9rem] flex flex-col gap-[0.75rem] md:gap-[1.25rem]">
                <img src={project.imgData[1]} alt="" className="rounded-lg w-full" />
            </section>
            <Collab />
            <Footer />
        </>
    )
}